import { get, put, Delete } from "../axios";

// OA approver list
export const oaApproverList = (params) => get("/web/auditor/list", params);

// OA approver update
export const oaApproverUpdate = (params) => put("/web/auditor/update", params);

// OA approver region list
export const oaApproverRegionList = (params) =>
  get("/web/auditor/region/list", params);

// OA approver delete
export const oaApproverDelete = (id) =>
  Delete("/web/auditor/delete/" + id, "");
